<template>
  <div>
    <v-snackbar v-model="showsnackbar" bottom right color="#63028F">
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="showsnackbar = false">
          <v-icon size="15" color="white">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 sm12 md12 lg10 xl10>
        <v-layout pt-4 wrap>
          <v-flex xs12 sm12 md6 lg8 xl8 px-2>
            <div v-if="cart">
              <v-layout wrap>
                <v-flex xs6 sm6 md6 lg6 xl6 text-left class="align-self-center">
                  <span>
                    <v-icon color="#000000">mdi-cart</v-icon>
                  </span>
                  <span
                    style="
                      font-family: opensansbold;
                      font-size: 18px;
                      color: #000000;
                    "
                    class="pl-4"
                    >My Cart</span
                  >
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xl12>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout
                v-for="(cartitems, index) in cart"
                :key="index"
                py-4
                wrap
                justify-start
              >
                <v-flex xs12 md2 style="background-color: transparent">
                  <v-img
                    :src="'http://13.235.2.39/u/' + cartitems.product.photos[0]"
                    height="100%"
                    contain
                  ></v-img>
                </v-flex>
                <v-flex px-12 xs12 md8 text-left>
                  <v-layout wrap>
                    <v-flex xs12>
                      <router-link
                        :to="
                          '/' +
                          cartitems.product._id +
                          '/' +
                          cartitems.product.productname
                        "
                      >
                        <span
                          style="
                            font-family: opensansbold;
                            font-size: 16px;
                            color: #000000;
                          "
                          class="text-capitalize"
                          >{{ cartitems.product.productname }}</span
                        >
                      </router-link>
                    </v-flex>
                    <v-flex xs12>
                      <span
                        style="
                          font-family: opensansbold;
                          font-size: 16px;
                          color: #000000;
                        "
                        class="text-capitalize"
                        >Price: ₹ {{ cartitems.product.price }}</span
                      >
                    </v-flex>
                    <v-layout wrap justify-start>
                      <v-flex xs3 text-left>
                        <star-rating
                          :rating="cartitems.product.ratingcount"
                          read-only
                          :show-rating="false"
                          :star-size="14"
                        ></star-rating>
                      </v-flex>
                      <v-flex offset-md-n2 text-left>
                        <span
                          style="
                            font-family: opensansregular;
                            font-size: 12px;
                            color: #292929;
                          "
                          class="text-capitalize"
                          >{{ cartitems.product.ratingcount }} Rated</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-flex xs12>
                      <span
                        style="
                          font-family: opensansregular;
                          font-size: 12px;
                          color: #616161;
                        "
                        class="text-capitalize"
                        >Inclusive of all taxes</span
                      >
                    </v-flex>
                    <v-flex xs12>
                      <span
                        style="
                          font-family: opensansregular;
                          font-size: 14px;
                          color: #63028f;
                        "
                        class="text-capitalize"
                      >
                        <i>You Save: ₹51</i>
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <span
                        style="
                          font-family: opensansregular;
                          font-size: 14px;
                          color: #000000;
                        "
                        class="text-capitalize"
                        >Shipping Charge: ₹40</span
                      >
                    </v-flex>
                    <v-flex xs12 text-left>
                      <span
                        style="
                          font-family: opensansregular;
                          font-size: 14px;
                          color: #2dd986;
                        "
                        v-if="cartitems.product.isavailableinlocation"
                      >
                        <i>Product can be delivered to</i>
                        {{ appPincode }}
                      </span>
                      <span
                        style="
                          font-family: opensansregular;
                          font-size: 14px;
                          color: #d90429;
                        "
                        v-else
                      >
                        <i>Product can't be delivered to</i>
                        {{ appPincode }}
                      </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap>
                        <v-flex xs6 md4 pt-4 text-left>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                outlined
                                color="#E2E2E2"
                                light
                                v-bind="attrs"
                                v-on="on"
                              >
                                <span
                                  style="
                                    font-family: opensansregular;
                                    font-size: 14px;
                                    color: #2a2a2a;
                                  "
                                  class="text-capitalize"
                                  >Qty:</span
                                >
                                <span
                                  style="
                                    font-family: opensanssemibold;
                                    font-size: 16px;
                                    color: #2a2a2a;
                                    padding-left: 10px;
                                  "
                                  >{{ cartitems.quantity }}</span
                                >
                                <span style="color: #2a2a2a; padding-left: 5px">
                                  <v-icon size="15">mdi-chevron-down</v-icon>
                                </span>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                color="red"
                                v-for="(item, index2) in cartitems.quantities"
                                :key="index2"
                              >
                                <v-list-item-title
                                  @click="
                                    qtyUpdate(cartitems.product, item, index)
                                  "
                                  >{{ item }}</v-list-item-title
                                >
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-flex>
                        <v-flex xs6 md4 pt-4 px-2 text-left>
                          <v-btn
                            small
                            text
                            dark
                            depressed
                            :ripple="false"
                            color="#000000"
                            @click="removeFromCart(cartitems.product._id)"
                          >
                            <span
                              style="
                                font-family: opensanssemibold;
                                font-size: 14px;
                              "
                              >REMOVE</span
                            >
                          </v-btn>
                        </v-flex>
                        <v-flex xs6 md4 pt-4 px-2 text-left>
                          <v-btn
                            @click="savedForLater(cartitems.product._id)"
                            small
                            text
                            dark
                            depressed
                            :ripple="false"
                            color="#000000"
                          >
                            <span
                              style="
                                font-family: opensanssemibold;
                                font-size: 14px;
                              "
                              >SAVE FOR LATER</span
                            >
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex py-4 xs12>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
            </div>
            <!-- ............saved.............. -->
            <div v-if="saved">
              <v-layout wrap>
                <v-flex xs6 sm6 md6 lg6 xl6 text-left class="align-self-center">
                  <span>
                    <v-icon color="#000000">mdi-cart</v-icon>
                  </span>
                  <span
                    style="
                      font-family: opensansbold;
                      font-size: 18px;
                      color: #000000;
                    "
                    class="pl-4"
                    >Saved For Later</span
                  >
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xl12>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout
                v-for="cartitems in saved"
                :key="cartitems._id"
                py-4
                wrap
                justify-start
              >
                <v-flex xs12 md2 style="background-color: transparent">
                  <v-img
                    :src="'http://13.235.2.39/u/' + cartitems.photos[0]"
                    height="100%"
                    contain
                  ></v-img>
                </v-flex>
                <v-flex px-12 xs12 md8 text-left>
                  <v-layout wrap>
                    <v-flex xs12>
                      <span
                        style="
                          font-family: opensansbold;
                          font-size: 16px;
                          color: #000000;
                        "
                        class="text-capitalize"
                        >{{ cartitems.productname }}</span
                      >
                    </v-flex>
                    <v-flex xs12>
                      <span
                        style="
                          font-family: opensansbold;
                          font-size: 16px;
                          color: #000000;
                        "
                        class="text-capitalize"
                        >Price: ₹ {{ cartitems.price }}</span
                      >
                    </v-flex>
                    <v-layout wrap justify-start>
                      <v-flex xs3 text-left>
                        <star-rating
                          :rating="cartitems.ratingcount"
                          read-only
                          :show-rating="false"
                          :star-size="14"
                        ></star-rating>
                      </v-flex>
                      <v-flex offset-md-n2 text-left>
                        <span
                          style="
                            font-family: opensansregular;
                            font-size: 12px;
                            color: #292929;
                          "
                          class="text-capitalize"
                          >{{ cartitems.ratingcount }} Rated</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-flex xs12>
                      <span
                        style="
                          font-family: opensansregular;
                          font-size: 12px;
                          color: #616161;
                        "
                        class="text-capitalize"
                        >Inclusive of all taxes</span
                      >
                    </v-flex>
                    <v-flex xs12>
                      <span
                        style="
                          font-family: opensansregular;
                          font-size: 14px;
                          color: #63028f;
                        "
                        class="text-capitalize"
                      >
                        <i>You Save: ₹51</i>
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <span
                        style="
                          font-family: opensansregular;
                          font-size: 14px;
                          color: #000000;
                        "
                        class="text-capitalize"
                        >Shipping Charge: ₹40</span
                      >
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap>
                        <v-flex xs6 md4 pt-4 text-left></v-flex>
                        <v-flex xs6 md4 pt-4 px-2 text-left>
                          <v-btn
                            small
                            text
                            dark
                            depressed
                            :ripple="false"
                            color="#000000"
                            @click="removeFromSaved(cartitems._id)"
                          >
                            <span
                              style="
                                font-family: opensanssemibold;
                                font-size: 14px;
                              "
                              >REMOVE</span
                            >
                          </v-btn>
                        </v-flex>
                        <v-flex xs6 md4 pt-4 px-2 text-left>
                          <v-btn
                            @click="moveToCart(cartitems._id)"
                            small
                            text
                            dark
                            depressed
                            :ripple="false"
                            color="#000000"
                          >
                            <span
                              style="
                                font-family: opensanssemibold;
                                font-size: 14px;
                              "
                              >MOVE TO CART</span
                            >
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex py-4 xs12>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="!cart && !saved">
              <v-layout wrap>
                <v-flex pt-4 xs12 text-center>
                  <span
                    style="
                      font-family: opensansbold;
                      font-size: 18px;
                      color: #000000;
                    "
                    >Sorry, You have no Items in the Cart</span
                  >
                </v-flex>
              </v-layout>
            </div>
          </v-flex>

          <v-flex px-2 md4 xl3>
            <v-layout wrap>
              <v-flex py-1 xs12 text-left>
                <span
                  style="
                    font-family: opensansbold;
                    font-size: 18px;
                    color: #000000;
                  "
                  >₹ Price Details</span
                >
              </v-flex>
              <v-flex py-1 xs12>
                <v-divider></v-divider>
              </v-flex>
              <v-flex py-1 xs12>
                <v-layout wrap>
                  <v-flex xs6 text-left>
                    <span
                      style="
                        font-family: opensanssemibold;
                        font-size: 14px;
                        color: #000000;
                      "
                      >Price ({{ cartlen }} Items)</span
                    >
                  </v-flex>
                  <v-flex xs6 text-left>
                    <span
                      style="
                        font-family: opensanssemibold;
                        font-size: 14px;
                        color: #000000;
                      "
                      >₹ {{ finalamount }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex py-1 xs12>
                <v-layout wrap>
                  <v-flex xs6 text-left>
                    <span
                      style="
                        font-family: opensanssemibold;
                        font-size: 14px;
                        color: #000000;
                      "
                      >Delivery Fee</span
                    >
                  </v-flex>
                  <v-flex xs6 text-left>
                    <span
                      style="
                        font-family: opensanssemibold;
                        font-size: 14px;
                        color: #000000;
                      "
                      >₹ {{ shippingCharge }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex py-1 xs12>
                <v-divider></v-divider>
              </v-flex>
              <v-flex py-1 xs12>
                <v-layout wrap>
                  <v-flex xs6 text-left>
                    <span
                      style="
                        font-family: opensansbold;
                        font-size: 14px;
                        color: #000000;
                      "
                      >Total Amount</span
                    >
                  </v-flex>
                  <v-flex xs6 text-left>
                    <span
                      style="
                        font-family: opensansbold;
                        font-size: 18px;
                        color: #000000;
                      "
                      >₹ {{ total }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex py-1 xs12>
                <v-divider></v-divider>
              </v-flex>
              <v-flex py-1 xs12 text-left>
                <span
                  style="
                    font-family: opensanssemibold;
                    font-size: 12px;
                    color: #63028f;
                  "
                  >You Save : ₹102 in this order</span
                >
              </v-flex>
              <v-flex pt-12 py-1 xs12>
                <v-btn
                  small
                  dark
                  block
                  depressed
                  :ripple="false"
                  color="#63028F"
                  @click="checkOut"
                >
                  <span
                    style="font-family: opensansregular; font-size: 14px"
                    class="text-capitalize"
                    >Check Out</span
                  >
                </v-btn>
              </v-flex>
              <v-flex py-4 xs12>
                <v-card color="#F9F9F9" flat>
                  <v-layout pt-4 wrap pa-2>
                    <v-flex xs9 text-left>
                      <span
                        style="
                          font-family: opensansbold;
                          font-size: 14px;
                          color: #474747;
                        "
                        class="px-2"
                        >Shipping Information</span
                      >
                    </v-flex>
                    <v-flex v-if="deliveryAddressEditIcon" px-4 xs3 text-right>
                      <v-icon @click="deliveryAddressModify('edit')" size="20"
                        >mdi-lead-pencil</v-icon
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="showDeliveryAddress" pa-2 wrap>
                    <v-flex py-1 xs12 text-left>
                      <v-icon size="16" color="#63028F"
                        >mdi-account-circle-outline</v-icon
                      >
                      <span
                        style="
                          font-family: opensanssemibold;
                          font-size: 12px;
                          color: #474747;
                        "
                        class="px-2"
                        >{{ deliveryAddress.fullname }}</span
                      >
                    </v-flex>
                    <v-flex py-1 xs12 text-left>
                      <v-icon size="16" color="#63028F"
                        >mdi-map-marker-outline</v-icon
                      >
                      <span
                        style="
                          font-family: opensanssemibold;
                          font-size: 12px;
                          color: #474747;
                        "
                        class="px-2"
                        >{{ deliveryAddress.streetAddress }},
                        {{ deliveryAddress.city }}, {{ deliveryAddress.state }},
                        {{ deliveryAddress.pincode }}</span
                      >
                    </v-flex>
                    <v-flex py-1 xs12 text-left>
                      <v-icon size="16" color="#63028F"
                        >mdi-phone-outline</v-icon
                      >
                      <span
                        style="
                          font-family: opensanssemibold;
                          font-size: 12px;
                          color: #474747;
                        "
                        class="px-2"
                        >{{ deliveryAddress.phone }}</span
                      >
                    </v-flex>
                    <v-flex py-1 xs12 text-left>
                      <v-icon size="16" color="#63028F"
                        >mdi-email-outline</v-icon
                      >
                      <span
                        style="
                          font-family: opensanssemibold;
                          font-size: 12px;
                          color: #474747;
                        "
                        class="px-2"
                        >{{ userData.email }}</span
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout v-else pa-2 wrap>
                    <v-flex
                      v-if="!deliveryAddressEdit"
                      @click="deliveryAddressEdit = true"
                      py-6
                      xs12
                      text-center
                    >
                      <v-icon size="30px">mdi-plus</v-icon>
                    </v-flex>
                  </v-layout>
                  <v-layout px-2 v-if="deliveryAddressEdit" wrap>
                    <v-flex py-1 xs12>
                      <v-text-field
                        prepend-icon="mdi-account"
                        label="Name"
                        type="text"
                        color="#63028F"
                        class="form-control"
                        id="name"
                        hide-details
                        v-model="deliveryAddress.fullname"
                        required
                      />
                    </v-flex>
                    <v-flex py-1 xs12>
                      <v-text-field
                        prepend-icon="mdi-cellphone-iphone"
                        label="Mobile Number"
                        type="text"
                        color="#63028F"
                        class="form-control"
                        id="phone"
                        v-model="deliveryAddress.phone"
                        hide-details
                        required
                      />
                    </v-flex>
                    <v-flex py-1 xs12>
                      <v-textarea
                        label="Address"
                        auto-grow
                        color="#63028F"
                        prepend-icon="mdi-account-box-outline"
                        rows="3"
                        v-model="deliveryAddress.streetAddress"
                        hide-details
                        row-height="8"
                      />
                    </v-flex>
                    <v-flex py-1 xs12>
                      <v-text-field
                        prepend-icon="mdi-zip-box"
                        label="Pincode"
                        type="text"
                        color="#63028F"
                        class="form-control"
                        id="pincode"
                        hide-details
                        v-model="deliveryAddress.pincode"
                        required
                      />
                    </v-flex>
                    <v-flex py-1 xs12>
                      <v-text-field
                        prepend-icon="mdi-city"
                        label="City"
                        type="text"
                        color="#63028F"
                        class="form-control"
                        id="city"
                        hide-details
                        v-model="deliveryAddress.city"
                        required
                      />
                    </v-flex>
                    <v-flex py-1 xs12 text-left>
                      <v-select
                        v-model="deliveryAddress.state"
                        prepend-icon="mdi-map"
                        :items="states"
                        color="#63028F"
                        label="State"
                        hide-details
                        item-text="name"
                        item-value="name"
                      ></v-select>
                    </v-flex>

                    <v-flex
                      v-if="deliveryAddress._id != null"
                      xs12
                      py-2
                      text-center
                    >
                      <v-btn
                        :disabled="false"
                        class="text-capitalize hh prfont aplog mr-3"
                        dark
                        small
                        color="#63028F"
                        :ripple="false"
                        @click="deliveryAddressModify('update')"
                        >Submit</v-btn
                      >
                      <v-btn
                        :disabled="false"
                        class="text-capitalize hh prfont aplog"
                        dark
                        small
                        color="#63028F"
                        :ripple="false"
                        @click="deliveryAddressModify('cancel')"
                        >Cancel</v-btn
                      >
                    </v-flex>
                    <v-flex v-else xs12 py-2 text-center>
                      <v-btn
                        :disabled="false"
                        class="text-capitalize hh prfont aplog mr-3"
                        dark
                        small
                        color="#63028F"
                        :ripple="false"
                        @click="addDeliveryAddress"
                        >Submit</v-btn
                      >
                      <v-btn
                        :disabled="false"
                        class="text-capitalize hh prfont aplog"
                        dark
                        small
                        color="#63028F"
                        :ripple="false"
                        @click="deliveryAddressEdit = false"
                        >Cancel</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex py-4 xs12>
                <v-card color="#F9F9F9" flat>
                  <v-layout pt-4 wrap>
                    <v-flex xs12 text-left>
                      <span
                        style="
                          font-family: opensansbold;
                          font-size: 14px;
                          color: #474747;
                        "
                        class="px-2"
                        >Payment Method</span
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout pa-2 wrap>
                    <v-flex xs12 text-left>
                      <v-radio-group v-model="paymentMethod">
                        <v-radio value="payNow" color="#63028F" :ripple="false">
                          <template v-slot:label>
                            <span
                              style="
                                font-family: opensanssemibold;
                                font-size: 14px;
                              "
                            >
                              Pay Now
                            </span>
                          </template>
                        </v-radio>
                        <v-radio value="COD" color="#63028F" :ripple="false">
                          <template v-slot:label>
                            <span
                              style="
                                font-family: opensanssemibold;
                                font-size: 14px;
                              "
                            >
                              Cash On Delivery
                            </span>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import axios from "axios";
import store from "./../../store";
export default {
  data() {
    return {
      pincode: localStorage.getItem("pincode"),
      quantities: [],
      productQuantity: 1,
      appLoading: false,
      cartlen: null,
      shippingCharge: null,
      finalamount: null,
      total: null,
      cart: [],
      saved: [],
      showsnackbar: false,
      deliveryAddressEdit: false,
      showDeliveryAddress: false,
      deliveryAddressEditIcon: false,
      data: [],
      states: [],
      districts: [],
      sid: "",
      msg: "",
      deliveryAddress: {
        _id: null,
        fullname: null,
        streetAddress: null,
        phone: null,
        locality: "",
        country: "India",
        state: null,
        pincode: null,
        city: null,
      },
      userData: {
        deliveryaddress: [],
      },
      delid: "",
      checkbox: false,
      order_id: null,
      paymentMethod: "payNow",
    };
  },
  beforeMount() {
    this.getDataCart();
    this.getDataSaved();
    this.getProfile();
    this.statesList();
  },
  computed: {
    appPincode() {
      var vm = this;
      vm.pincode = store.state.pincode;
      this.getDataCart();
      this.getProfile();
      return store.state.pincode;
    },
  },
  methods: {
    checkOut() {
      this.buyNow();
    },
    changeDeliveryDetails() {
      if (this.pincode != this.deliveryAddress.pincode) {
        this.deliveryAddress = {
          fullname: null,
          streetAddress: null,
          phone: null,
          locality: "",
          country: "India",
          state: null,
          pincode: this.pincode,
          city: null,
        };
        console.log("Changing Shipping Details");
      } else {
        console.log("Can't Change Shipping Details");
      }
    },
    buyNow() {
      var data = {};
      data["deliveryaddressindex"] = this.userData.deliveryaddress[0]._id;
      data["amount"] = this.finalamount;
      data["fullname"] = this.userData.fullname;
      data["mobile"] = this.userData.phone;
      data["email"] = this.userData.email;
      data["address"] = this.userData.streetAddress;
      data["type"] = "web";
      data["paymentmethod"] = this.paymentMethod;
      axios({
        method: "post",
        url: "/payment/checkout",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.status) {
            this.order_id = res.data.order_id;
            // Initiation of Razorpay PG
            var rzp1 = new Razorpay({
              key: "rzp_test_R39se114Y6Xlkf",
              amount: res.data.amount,
              name: res.data.customer_details.name,
              currency: "INR",
              description: "Web Peedika",
              image: "webpeedika.png",
              order_id: res.data.order_id,

              // "handler": function (response){
              //   alert(response.razorpay_payment_id);
              // },

              prefill: {
                name: this.userData.fullname,
                email: this.userData.email,
              },

              notes: {
                address: "",
              },

              theme: {
                color: "#00ffff",
              },
              order_id: res.data.order_id,
              callback_url: "http://webpeedika.com/Payment/" + this.order_id,
              // callback_url: "http://localhost:8080/Payment/" + this.order_id,
              redirect: true,
            });
            rzp1.open();
          } else {
            this.msg = res.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          console.log("ERR", err);
        });
    },
    deliveryAddressModify(item) {
      if (item == "edit") {
        this.showDeliveryAddress = false;
        this.deliveryAddressEdit = true;
        this.deliveryAddressEditIcon = false;
      }
      if (item == "cancel") {
        this.showDeliveryAddress = true;
        this.deliveryAddressEdit = false;
        this.deliveryAddressEditIcon = true;
      }
      if (item == "update") {
        this.editDeliveryAddress();
      }
    },
    getDataCart() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/Cart/all",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          pincode: localStorage.getItem("pincode"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.cart = response.data.cart;
          this.data = response.data;
          if (response.data.cart) {
            this.cartlen = response.data.cart.length;
            this.total = response.data.total;
            this.shippingCharge = response.data.shippingcharge;
            this.finalamount = response.data.finalamount;

            for (var i = 0; i < this.cart.length; i++) {
              this.cart[i].quantities = [];
              for (var j = 1; j <= this.cart[i].product.stockquantity; j++) {
                this.cart[i].quantities.push(j);
              }
            }
          } else {
            this.cartlen = 0;
            this.total = 0;
            this.shippingCharge = 0;
            this.finalamount = 0;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getDataSaved() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/SaveForLater/all",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.saved = response.data.SaveForLaterModel;
          this.data = response.data;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.userData = response.data.data;
          if (this.userData.deliveryaddressindex) {
            for (var i = 0; i < this.userData.deliveryaddress.length; i++) {
              if (
                this.userData.deliveryaddressindex ==
                this.userData.deliveryaddress[i]._id
              ) {
                this.deliveryAddress = this.userData.deliveryaddress[i];
                this.showDeliveryAddress = true;
                this.deliveryAddressEditIcon = true;
              }
            }
          } else {
            if (this.userData.deliveryaddress.length > 0) {
              this.showDeliveryAddress = true;
              this.deliveryAddress = this.userData.deliveryaddress[0];
              this.deliveryAddressEditIcon = true;
            } else {
              this.showDeliveryAddress = false;
              this.deliveryAddress.fullname = this.userData.fullname;
              this.deliveryAddress.phone = this.userData.phone;
              this.deliveryAddress.pincode = this.userData.currentpincode;
            }
          }
          // this.changeDeliveryDetails();
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    addDeliveryAddress() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/deliveryaddress/add",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.deliveryAddress,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            store.commit("changePincode", this.deliveryAddress.pincode);
            this.deliveryAddressEdit = false;
            this.showDeliveryAddress = true;
            this.deliveryAddressEditIcon = true;
          } else {
            this.msg = "Semothing went wrong";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    editDeliveryAddress() {
      this.appLoading = true;
      this.deliveryAddress.id = this.deliveryAddress._id;
      axios({
        method: "POST",
        url: "/deliveryaddress/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.deliveryAddress,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            store.commit("changePincode", this.deliveryAddress.pincode);
            this.deliveryAddressEdit = false;
            this.showDeliveryAddress = true;
            this.deliveryAddressEditIcon = true;
          } else {
            this.msg = "Semothing went wrong";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    statesList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/loc/StateList",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.states = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    removeFromCart(pid) {
      var cart = {};
      cart["productid"] = pid;
      axios({
        method: "POST",
        url: "/Cart/Remove",
        data: cart,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            store.commit("changeCart", response.data.count);
            this.showsnackbar = true;
            this.msg = "Removed Successfully";
            this.getDataCart();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    savedForLater(pid) {
      var cart = {};
      cart["productid"] = pid;
      axios({
        method: "POST",
        url: "/SaveForLater/Add",
        data: cart,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.getDataCart();
            this.getDataSaved();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    qtyUpdate(item, qty, index) {
      this.cart[index].product.quantity = qty;
      var cart = {};
      cart["productid"] = item._id;
      cart["quantity"] = qty;
      axios({
        method: "POST",
        url: "/Cart/Addorupdate",
        data: cart,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.getDataCart();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    removeFromSaved(pid) {
      var cart = {};
      cart["productid"] = pid;
      axios({
        method: "POST",
        url: "/SaveForLater/Remove",
        data: cart,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.showsnackbar = true;
            this.msg = "Removed Successfully";
            this.getDataSaved();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    moveToCart(pid) {
      var cart = {};
      cart["productid"] = pid;
      axios({
        method: "POST",
        url: "/SaveForLater/movetocart",
        data: cart,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.getDataCart();
            this.getDataSaved();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style >
.v-list {
  height: 300px; /* or any height you want */
  overflow-y: auto;
}
.theme--light.v-list {
  background: #ffffff;
  color: #63028f;
}
</style>